import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'modules/i18n';

import { GetTasksResult } from '../../actions/getTasks';
import { Empty } from '../Empty/Empty';
import { ListItem } from './ListItem';
import { Row } from './Row';
import translation from './tasksTable.translation';

interface Props {
  tasks: GetTasksResult;
}

export function TasksTable({ tasks }: Props): JSX.Element {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);

  return (
    <div>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeadCell}>
                {t(keys.name)}
              </TableCell>

              <TableCell className={classes.tableHeadCell}>
                {t(keys.status)}
              </TableCell>

              <TableCell className={classes.tableHeadCell}>
                {t(keys.address)}
              </TableCell>

              <TableCell align="right" className={classes.tableHeadCell}>
                {t(keys.amountSpent)}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tasks.map(task => (
              <Row key={task.id} task={task} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div className={classes.list}>
        {tasks.map(task => (
          <ListItem key={task.id} task={task} />
        ))}
      </div>

      {!tasks.length && <Empty />}
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  tableContainer: {
    '&&': {
      overflowX: 'initial',
    },

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  tableHeadCell: {
    whiteSpace: 'nowrap',
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));
